import { DetailedHTMLProps, FC, InputHTMLAttributes } from 'react'
import { StyledTitle } from './styled'

const Subtitle: FC<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = ({ children, ...rest }) => <StyledTitle {...rest}>{children}</StyledTitle>

export default Subtitle
